import * as d3 from 'd3';
import { colours } from '../../_styleguide/_colours';
var ChartAxisGrid = /** @class */ (function () {
    function ChartAxisGrid(config, dataMapping, svg) {
        this.config = config;
        this.dataMapping = dataMapping;
        this.svg = svg;
    }
    ChartAxisGrid.prototype.make_x_gridlines = function (scale, ticksNo) {
        return d3.axisBottom(scale)
            .ticks(ticksNo)
            .tickFormat(function (d) { return ""; });
    };
    ChartAxisGrid.prototype.make_y_gridlines = function (scale, ticksNo) {
        return d3.axisLeft(scale)
            .ticks(ticksNo)
            .tickFormat(function (d) { return ""; });
    };
    ChartAxisGrid.prototype.clear = function () {
        this.svg.layers.underData.selectAll("g").remove();
    };
    ChartAxisGrid.prototype.draw = function () {
        this.xGrid = this.svg.layers.underData.append("g")
            .attr("class", "grid x-grid")
            .attr("fill", "transparent")
            .attr("stroke", colours.lightGrey);
        this.yGrid = this.svg.layers.underData.append("g")
            .attr("class", "grid y-grid")
            .attr("fill", "transparent")
            .attr("stroke", colours.lightGrey);
    };
    ChartAxisGrid.prototype.redraw = function (dimensions, xScale, yScale, direction, data) {
        var self = this;
        switch (direction) {
            case 'horizontal':
                this.yGrid
                    .attr("transform", "translate(" + 0 + "," + 0 + ")")
                    .style('opacity', 1);
                this.xGrid
                    .style('opacity', 0);
                break;
            case 'vertical':
                this.yGrid
                    .style('opacity', 0);
                this.svg.layers.underData.selectAll('.x-grid')
                    .attr("transform", "translate(" + (0 - (xScale.bandwidth() / 2)) + "," + dimensions.height + ")")
                    .style('opacity', 1);
                break;
            case 'plot':
                this.xGrid
                    .attr("transform", "translate(" + (0 - (xScale.bandwidth() / 2)) + "," + dimensions.height + ")")
                    .style('opacity', 1);
                this.yGrid
                    .attr("transform", "translate(" + 0 + "," + (0 - (yScale.bandwidth() / 2)) + ")")
                    .style('opacity', 1);
                break;
        }
        this.xGrid
            .call(this.make_x_gridlines(xScale, data.length)
            .tickSize(-dimensions.height)
        // .tickFormat("")
        );
        this.xGrid.selectAll(".tick line").attr("stroke", colours.lightGrey);
        this.xGrid.selectAll(".tick text").attr("fill", "black");
        this.xGrid.selectAll("path.domain").attr("opacity", 0);
        // add the Y gridlines
        this.yGrid
            .transition()
            .duration(1000)
            .call(this.make_y_gridlines(yScale, '4')
            .tickSize(-dimensions.width));
        this.yGrid.selectAll(".tick line").attr("stroke", colours.lightGrey);
        this.yGrid.selectAll("path.domain").attr("opacity", 0);
    };
    return ChartAxisGrid;
}());
export { ChartAxisGrid };
